import { Link } from "react-router-dom";
import { specialtySearchUrl } from "../../Services/SpecializationService";

const CITIES = ["Karachi", "Lahore", "Islamabad", "Rawalpindi", "Multan", "Peshawar", "Gujranwala"];

const SPECIALTIES = [
    { label: "Child Specialists", specialty: "Child Specialist" },
    { label: "ENT Specialists", specialty: "ENT Specialist" },
    { label: "Gynecologists", specialty: "Gynecologist" },
    { label: "Dentists", specialty: "Dentist" },
    { label: "Dermatologists", specialty: "Dermatologist" },
    { label: "Eye Specialists", specialty: "Eye Specialist" },
    { label: "Dietitians / Nutritionists", specialty: "Dietitian/Nutritionist" },
];

const COMPANY_LINKS = [
    { label: "About Us", to: "/about" },
    { label: "Contact Us", to: "/contact" },
    { label: "Refund Policy", to: "/refund-policy" },
    { label: "Payment Terms", to: "/payment-terms" },
    { label: "Terms of Use", to: "/terms-of-use" },
    { label: "Privacy Policy", to: "/privacy-policy" },
];

const linkClass = "text-gray-700 hover:text-[#3e7cc4] transition-colors";

const Footer = () => {
    return (
        <footer className="bg-[#f3f6fb] text-gray-800 border-t border-gray-200">
            <div className="max-w-screen-xl mx-auto px-4 py-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
                <div>
                    <Link to="/" className="inline-block mb-4">
                        <img src="/img/final-logo.png" alt="Famra Cure" className="w-40 h-auto" />
                    </Link>
                    <p className="text-sm leading-relaxed text-gray-700 mb-4 max-w-xs">
                        Book appointments with the best Doctors and Specialists such as Gynecologists,
                        Skin Specialists, Child Specialists, Surgeons, etc. in Pakistan conveniently.
                    </p>
                    <div className="flex gap-4 text-lg text-gray-700">
                        <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="hover:text-[#3e7cc4]"><i className="fab fa-facebook-f"></i></a>
                        <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="X (Twitter)" className="hover:text-[#3e7cc4]"><i className="fab fa-twitter"></i></a>
                        <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="hover:text-[#3e7cc4]"><i className="fab fa-instagram"></i></a>
                    </div>
                </div>

                <div>
                    <h3 className="font-bold text-gray-900 mb-3">Cities</h3>
                    <ul className="text-sm space-y-2">
                        {CITIES.map((city) => (
                            <li key={city}>
                                <Link to={`/search-doctor?city=${encodeURIComponent(city)}`} className={linkClass}>
                                    Doctors in {city}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                <div>
                    <h3 className="font-bold text-gray-900 mb-3">Specialties</h3>
                    <ul className="text-sm space-y-2">
                        {SPECIALTIES.map((item) => (
                            <li key={item.specialty}>
                                <Link to={specialtySearchUrl(item.specialty)} className={linkClass}>
                                    {item.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                <div>
                    <h3 className="font-bold text-gray-900 mb-3">Company</h3>
                    <ul className="text-sm space-y-2">
                        {COMPANY_LINKS.map((item) => (
                            <li key={item.to}>
                                <Link to={item.to} className={linkClass}>{item.label}</Link>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
            <div className="bg-[#1e4080] text-center py-4">
                <p className="text-sm text-white">© {new Date().getFullYear()} Famra Cure. All rights reserved.</p>
            </div>
        </footer>
    );
};

export default Footer;
